import _ from 'lodash'
import { baseApi } from './base'
import { CreateStaffDto, Staff } from '../models/staff.model'
import { SearchRequestOptions } from '../types/request'
import { SearchResponse } from '../types/response'

export type GetStaffsParams = { query: Record<string, any>; options?: SearchRequestOptions }

export const staffApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    addStaff: builder.mutation<Staff, CreateStaffDto>({
      query: (body) => ({ url: '/staffs', method: 'POST', body }),
    }),
    getStaff: builder.query<Staff, string>({
      query: (staffId) => `/staffs/${staffId}`,
    }),
    getStaffs: builder.query<SearchResponse<Staff>, GetStaffsParams>({
      query: ({ query, options }) => ({
        url: '/staffs/query',
        method: 'POST',
        body: { query, options: _.merge({}, { limit: 5, order: 'ASC', skip: 0 }, options) },
      }),
      transformResponse: (response: [Staff[], number]) => {
        return { items: response[0], totalCount: response[1] }
      },
    }),
    getStaffsByEstablishment: builder.query<Staff[], string>({
      query: (establishmentId) => `/staffs/establishments/${establishmentId}`,
    }),
    rejectLicense: builder.mutation<Staff, { licenseId: string; staffId: string }>({
      query: ({ licenseId, staffId }) => ({
        url: `/staffs/${staffId}/licenses/${licenseId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
})
